import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Label } from '@onclicks/sharedcomponents/ui/Label'
import { Textarea as TextAreaComponent } from '@onclicks/sharedcomponents/ui/Textarea'
import React from 'react'

import { Error } from '@onclicks/sharedcomponents/FieldForm/Error'
import { Width } from '@onclicks/sharedcomponents/FieldForm/Width'

export const Textarea: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>
    placeholder?: string
    register: UseFormRegister<FieldValues>
    rows?: number
  }
> = ({ name, defaultValue, errors, label, placeholder, register, required, rows = 7, width }) => {
  return (
    <Width width={width}>
      <div className="flex flex-col gap-2">
        <Label
          htmlFor={name}
          className="text-xs font-semibold tracking-[0.2em] text-neutral-500 uppercase"
        >
          {label}

          {required && (
            <span className="required">
              * <span className="sr-only">(required)</span>
            </span>
          )}
        </Label>

        <TextAreaComponent
          defaultValue={defaultValue}
          id={name}
          rows={rows}
          placeholder={placeholder}
          className="rounded-none border-0 border-b border-black/30 bg-transparent px-0 py-2 text-sm focus:border-black focus:ring-0 focus-visible:ring-0 placeholder:text-neutral-500"
          {...register(name, { required: required })}
        />

        {errors[name] && <Error name={name} />}
      </div>
    </Width>
  )
}
